import { useState } from "react";
import "./App.css";
import { ValidateAddress } from "./validate_address";
function App() {
  const [data, setData] = useState<any>();

  return (
    <div className="App">
      <h2>ESID Lookup</h2>
      <p>
        Your ESID Number, or Electric Service Identifier, is a number that is
        unique to your property address. Pronounced “Easy I.D.” it’s also known
        as an ESIID, ESI ID or ESI-ID. You can’t find your Texas meter number or
        ESID on your actual physical meter. But you can find it using our free
        ERCOT ESID Lookup Tool.
      </p>

      <div className="address-section">
        <div className="content-section">
          <h2>What’s my ESIID number?</h2>
          <ValidateAddress handleSave={(val: any) => setData(val)} />
          {data && (
            <div className="esiid-section">
              <div className="esiid-content">
                <p>
                  <strong>ESIID: </strong>
                  {data.address.esiid}
                </p>
                <p>
                  <strong>Address: </strong>
                  {data.address.value}
                </p>
                <p>
                  <strong>Status: </strong>
                  {data.address.status}
                </p>
                <p>
                  <strong>Premise Type: </strong>
                  {data.address.premise_type}
                </p>
                <p>
                  <strong>Utility: </strong>
                  {data.utility.utility_name}
                </p>
                {/* <p>
                  <strong>Load Zone: </strong>
                  {data.address.city.toUpperCase()}
                </p> */}
              </div>
            </div>
          )}
          <img
            src={"/esiid/images/HomeEnergyClub-Logo.svg"}
            height={20}
            className="logo"
          />
        </div>
      </div>


      {/* <iframe src="https://disoorqocx788.cloudfront.net/" height={400} width={700}/> */}
    </div>
  );
}

export default App;
